export const pageSecondaryHeaderTabContainerStyles = [
  // Overlap the header's bottom border with the active tab's border
  "-mb-[calc(var(--page-header-padding)+var(--page-header-bottom-border-width))]",
  "@xl/page-header:-mt-2",
  // Keep the header at its `min-h-16` height, with the tabs flush to the bottom
  "@6xl/page-header:mt-[calc(var(--page-header-padding)_-_var(--page-header-bottom-border-width))]"
]
